export const AREACODES = [
  {
    code: '31',
    name: 'Nederland',
    shortCode: 'NL',
  },
  {
    code: '33',
    name: 'Frankrijk',
    shortCode: 'FR',
  },
  {
    code: '34',
    name: 'Spanje',
    shortCode: 'ES',
  },
  {
    code: '39',
    name: 'Italië',
    shortCode: 'IT',
  },
  {
    code: '44',
    name: 'Verenigd Koninkrijk',
    shortCode: 'GB',
  },
  {
    code: '45',
    name: 'Denemarken',
    shortCode: 'DK',
  },
  {
    code: '46',
    name: 'Zweden',
    shortCode: 'SE',
  },
  {
    code: '47',
    name: 'Noorwegen',
    shortCode: 'NO',
  },
  {
    code: '49',
    name: 'Duitsland',
    shortCode: 'DE',
  },
  {
    code: '90',
    name: 'Turkije',
    shortCode: 'TR',
  },
  {
    code: '358',
    name: 'Finland',
    shortCode: 'FI',
  },
];
